import React, { useState } from 'react';
import { useContext, useEffect } from 'react';
import Application from '../../../StateContext/Application';
import { Cancel32, DeleteRed32, EditBlueBlue32, submit, Tax32, UpdateWhite32, EditIcon, DeleteIcon, Edit32WHITE, Delete32WHITE } from '../../../../../public/LoginImages/importimages';
const ObjectCode = () => {
    const [objectCodes, setObjectCodes] = useState([]);
    const operation = useContext(Application)
    const { GetObjectCodes, AddObjectCode, UpdateObjectCode, DeleteObjectCode } = operation
    const [objectCode, setObjectCode] = useState("");
    const [editIndex, setEditIndex] = useState(null);
    const [hoveredButton, setHoveredButton] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        GetObjectCodes().then(data => {
            setObjectCodes(data.map((c, idx) => ({ id: c.id || idx, code: c.object_code || c })));
        });
    }, []);
    const handleInputChange = (e) => {
        setObjectCode(e.target.value);
    };
    // 01-10
const [currentPage, setCurrentPage] = useState(1);
const recordsPerPage = 5;
// ================= SEARCH =================
const filteredObjectCodes = objectCodes.filter((item) =>
    item.code.toLowerCase().includes(searchTerm.toLowerCase().trim())
);
 
// ================= PAGINATION =================
const totalPages = Math.ceil(
    filteredObjectCodes.length / recordsPerPage
); 
const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
const currentObjectCodes = filteredObjectCodes.slice(indexOfFirstRecord , indexOfLastRecord);
 
useEffect(() => {
    setCurrentPage(1);
}, [searchTerm]);

    // Handle edit button click
    const handleAddObjectCode = async () => {
        const newCode = objectCode.trim();
        if (!newCode) {
            alert("Please enter an object code.");
            return;
        }
        try {
            // UPDATE
            if (editIndex !== null) {
                const oldCode = objectCodes[editIndex].code;
                // Check duplicate except current record
                const duplicate = objectCodes.some(
                    (item, index) =>
                        index !== editIndex &&
                        item.code.trim().toLowerCase() === newCode.toLowerCase()
                );
    
                if (duplicate) {
                    alert("This Object Code already exists.");
                    return;
                }
                await UpdateObjectCode(oldCode, newCode);
                const updatedCodes = [...objectCodes];
                updatedCodes[editIndex] = {
                    ...updatedCodes[editIndex],
                    code: newCode,
                };
                setObjectCodes(updatedCodes);
                alert("Object Code updated successfully");
                setEditIndex(null);
                setObjectCode("");
                return;
            }
    
            // ADD - check duplicate
            const duplicate = objectCodes.some(
                (item) =>
                    item.code.trim().toLowerCase() === newCode.toLowerCase()
            );
    
            if (duplicate) {
                alert("This Object Code already exists.");
                return;
            }
    
            // Add to database
            await AddObjectCode(newCode);
    
            // Add to frontend list
            setObjectCodes((prev) => [
                
                {
                    id: Date.now(),
                    code: newCode,
                },
                ...prev, //15-10
            ]);
    
            alert("Object Code Added Successfully");
    setCurrentPage(1); 
            setObjectCode("");
    
        } catch (err) {
            console.error(err);
    
            if (editIndex !== null) {
                alert("Error updating object code");
            } else {
                alert("Error adding object code");
            }
        }
    };
    
    const handleEdit = (index) => {
        setObjectCode(objectCodes[index].code);

        setEditIndex(index);
    };

    const handleDelete = async (index) => {
        const item = objectCodes[index];
        if (!window.confirm(`Are you sure you want to delete object code: ${item.code}?`)) {
            return; // cancel if user clicks "Cancel"
        }
        try {
            await DeleteObjectCode(objectCodes[index].code);
            setObjectCodes(objectCodes.filter((_, i) => i !== index));
            alert("Object Code deleted Successfully")
        } catch (err) {
            console.error(err);
            alert("Error deleting object code");
        }
    };

    const getPageNumbers = (currentPage, totalPages) => {
        const maxVisiblePages = 5;
    
        if (totalPages <= maxVisiblePages) {
          return Array.from({ length: totalPages }, (_, index) => index + 1);
        }
    
        // Starting pages
        if (currentPage <= 3) {
          return [1, 2, 3, 4, 5, "...", totalPages];
        }
    
        // Ending pages
        if (currentPage >= totalPages - 2) {
          return [
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages,
          ];
        }
    
        // Middle pages
        return [
          "...",
          currentPage - 2,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          currentPage + 2,
          "...",
          totalPages,
        ];
      };


   return (
           <div style={{ background: "#ffffff", width: "100%",   minHeight: "89vh",height:"89vh" ,  padding: "18px 25px", boxSizing: "border-box", fontFamily: "Inter, sans-serif", overflowY: "auto"}}>
           <div style={{    width: "100%",  maxWidth: "1000px",  margin: "0 auto" }}>
               {/* //30/10 */}
                   <h5  style={{  margin: "0 0 14px 0",  fontSize: "22px", fontWeight: "700", color: "#111", display: "flex", alignItems: "center" }}>
                       <img src={"/Object-Code-32.png"} alt="Project Icon" style={{ marginRight: "8px", width: "20px", height: "20px" }} />   Object Code Management</h5>
                 
                 {/* //30/10 */}
                       <div  style={{width: "100%", backgroundColor: "#EEF1F6", border: "1px solid #b9d9ff",  borderRadius: "6px",  padding: "24px 20px", boxSizing: "border-box",  marginBottom: "14px"  }}>
                           <div  style={{
               display: "flex",
               alignItems: "center",
               width: "100%",
               gap: "10px"
           }}>
                               <label htmlFor="objectCodeInput" className="form-label" style={{
                   fontWeight: "600",
                   fontSize: "12px",
                   minWidth: "65px",
                   margin: 0
               }}>Object Code</label>
                               <input
                                   type="text"
                                   id="objectCodeInput"
                                   className="form-control"
                                   style={{
                   flex: 1,
                   height: "34px",
                   border: "1px solid #999",
                   borderRadius: "6px",
                   padding: "6px 10px",
                   fontSize: "12px",
                   boxSizing: "border-box",
                   //24/10
                   border: editIndex !== null
                                       ? "2px solid #008dcc"
                                       : "1px solid #999",
   
                                   backgroundColor: editIndex !== null
                                       ? "#eef8ff"
                                       : "#ffffff",
                                   boxSizing: "border-box"
               }}
                                   value={objectCode}
                                   onChange={handleInputChange}
                                   placeholder="Enter Object Code"
                               />
   
                               <button
                           style={{
                       display: "flex",
                       justifyContent: "center",
                       alignItems: "center",
                       gap: "6px",
                       borderRadius: "6px",
                       width: "125px",
                       height: "32px",
                       backgroundColor: "#008dcc",
                       border: "none",
                       fontSize: "11px",
                       color: "#ffffff",
                       fontWeight: "600",
                       cursor: "pointer"
                   }}
                           onClick={handleAddObjectCode}
                       > <img src={submit} style={{ width: "1rem",paddingBottom: "3px",fontSize: "15px",  }}   />
                           {editIndex !== null ? "Update Object Code" : "Add Object Code"}
                       </button>
                           </div>
   
                       </div>
                   {/* </div> */}
   
                  
                       
                   </div>
   
               {/* </div> */}
               
   
   
   {/* 01-10 */}
               {/* {objectCodes.length > 0 && ( */}
   
   {/* //30/10 */}
   <div
     style={{
       width: "100%",
       maxWidth: "1000px",
       margin: "14px auto 0",
       background: "#EEF2F7",
       border: "1px solid #dfe5ee",
       borderRadius: "10px",
       padding: "15px 20px 20px",
       boxSizing: "border-box",
       marginTop:"20px"
     }}
   >
       {/* //30/10 */}
          <div style={{
                       display: "flex",
                       justifyContent: "space-between",
                       alignItems: "center",
                       marginBottom: "12px" }}>
                           
                       <h5 style={{
               margin: "8px",
               //30/10
               fontSize: "18px",
               fontWeight: "700",
               color: "#111",
               display: "flex",
               alignItems: "center"
           }} > Object List 
            </h5>
   
            <div style={{position:"relative",width:"230px"}}>
              <img
                                       src="/Search-32.png"
                                       alt="Search"
                                       style={{
                                           position: "absolute",
                                           left: "9px",
                                           top: "50%",
                                           transform: "translateY(-50%)",
                                           width: "14px",
                                           height: "14px"
                                       }}
                                   />
    
                                   <input  type="text"
                                       placeholder="Search object code"
                                        value={searchTerm}
       onChange={(e) => setSearchTerm(e.target.value)}
                                       style={{
                                           width: "100%",
                                           height: "36px",
                                           padding: "5px 10px 5px 30px",
                                           border: "1px solid #d0d7df",
                                           borderRadius: "6px",
                                           outline: "none",
                                           fontSize: "11px",
                                           boxSizing: "border-box"
                                       }} />
    
               </div>
                       
                       </div>
   
                 {/* //30/10 */}
                   <div  style={{
           width: "100%",
           backgroundColor: "#ffffff",
           boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
           borderRadius: "10px",
           padding: "16px",
           boxSizing: "border-box",
           marginTop: "20px"
       }}>
   
                    
                       <table style={{
           width: "100%",
           borderCollapse: "separate",
           borderSpacing: 0,
           border: "1px solid #d6e2f2",
           borderRadius: "6px",
           overflow: "hidden",
           fontSize: "12px"
       }}
    >
                           <thead>
                               {/* //28/10 */}
                               <tr style={{
           backgroundColor: "#2D79DB",
           color: "white",
           height: "10px",
           textAlign: "center",
           fontSize: "14px",
           fontWeight: "400"
       }}>
                                   <th style={{ padding: "8px", textAlign: "center" }}>Sr. No</th>
                                   <th style={{ padding: "8px", textAlign: "center" }}>Object Code</th>
                                   <th style={{ padding: "8px", textAlign: "center" }}>Action</th>
                               </tr>
                           </thead>
                           <tbody>
                               {/* 01-10  */}
       {/* {currentObjectCodes.map((item, index) => ( */}
        {currentObjectCodes.length > 0 ? (
           currentObjectCodes.map((item, index) => (
           <tr
               key={`${item.code}-${index}`}
               //28/10
               style={{
                   backgroundColor:
                       index % 2 === 0 ? "#E5F4FB" : "#CDE4F2",
                   height: "30px",
                   verticalAlign:"middle", textAlign: "center"
               }}>
               <td
                   style={{
                       padding: "4px 8px",
                       textAlign: "center",
                       height:"30px",
                       verticalAlign:"middle",
                       //3/11
                       border:"1px solid white"
   
                   }}
               >
                   {indexOfFirstRecord + index + 1}
               </td>
   
               <td
                  style={{
                       padding: "4px 8px",
                       textAlign: "center",
                       height:"30px",
                       verticalAlign:"middle",
                       //3/11
                      border:"1px solid white"
                   }}
               >
                   {item.code}
               </td>
   
               <td
                   style={{
                       padding: "4px 8px",
                       textAlign: "center",
                       verticalAlign:"middle",
                       //3/11
                       border:"1px solid white"
                   }}
               >
   
   
                   <div  style={{
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
               gap: "5px"
           }}>
                   <button
                   //24/10
                       style={{  backgroundColor:  hoveredButton === `edit-${item.id}` ? "#044c92" : "#ffffff",
                         color:  hoveredButton === `edit-${item.id}` ? "#ffffff" : "#044c92",
                           border: "1px solid #044c92",
   
                            borderRadius: "5px", padding: "2px 8px", fontSize: "10px", height: "28px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box"}}
                       onClick={() => handleEdit(indexOfFirstRecord + index)}
                     
                       //24/10
                          onMouseEnter={() => setHoveredButton(`edit-${item.id}`)}
                           onMouseLeave={() => setHoveredButton(null)}> Edit
                   
                      
                       {/* //24/10 */}
                        <img src={  hoveredButton === `edit-${item.id}`  ? Edit32WHITE  : EditIcon } alt="Edit Icon"  style={{ marginRight: "5px", width: 14, height: 14 }} />
                   </button>
   
                   <button
                       style={{  //24/10
                                   backgroundColor: hoveredButton === `delete-${item.id}` ? "#ee5d50" : "#ffffff",
                                     color:  hoveredButton === `delete-${item.id}` ? "#ffffff" : "#ee5d50",
                                       border: "1px solid #ee5d50",
   
                        borderRadius: "5px", padding: "2px 8px", fontSize: "10px",  height: "28px",  borderRadius: "5px", display: "flex", alignItems: "center",  justifyContent: "center", boxSizing: "border-box" }}
    
                       onClick={() => handleDelete(indexOfFirstRecord + index)  }
                       //24/10
                        onMouseEnter={() => setHoveredButton(`delete-${item.id}`)}
                        onMouseLeave={() => setHoveredButton(null)} >
                       {/* //24/10 */}
                       <img src={ hoveredButton === `delete-${item.id}` ? Delete32WHITE : DeleteIcon } alt="Delete Icon" style={{  marginRight: "5px", width: "14px", height: "14px",  objectFit: "contain",  flexShrink: 0  }}  />
                       Delete
                   </button>
               </div>
               </td>
            </tr>
             ))
       ) : (
           <tr>
               <td
                   colSpan="3"
                   style={{
                       textAlign: "center",
                       padding: "20px",
                       height: "80px",
                       color: "#777",
                       fontSize: "13px",
                       fontWeight: "500",
                       backgroundColor: "#f9f9f9"
                   }}
               >
                   No Data Available
               </td>
           </tr>
                                  )}
   </tbody>
    
    
                       </table>
                       {/* 30-09 no data msg
                         {currentObjectCodes.length === 0 && (
     <div
       style={{
         width: "100%",
         display: "flex",
         justifyContent: "center",
         alignItems: "center",
         height: "80px",
         boxSizing: "border-box",
         backgroundColor: "#f9f9f9",
         color: "#777",
         fontSize: "13px",
         fontWeight: 500,
         textAlign: "center",
       }}
     >
       No Data Available
     </div>
   )} */}
                        <div
                               style={{
                                   width: "100%",
                                   display: "flex",
                                   alignItems: "center",
                                   justifyContent: "space-between",
                                   marginTop: "15px",
                                   padding: "10px 5px",
                                   boxSizing: "border-box",
                               }}
                           >
                               {/* Showing Entries */}
                               <div
                                   style={{
                                       fontSize: "13px",
                                       color: "#333",
                                       whiteSpace: "nowrap",
                                   }}
                               >
                                   {/* Showing{" "}
                                   {objectCodes.length === 0
                                       ? 0
                                       : indexOfFirstRecord + 1}{" "}
                                   to{" "}
                                   {Math.min(
                                       indexOfLastRecord,
                                       objectCodes.length
                                   )}{" "}
                                   of {objectCodes.length} entries */}
                                   {/* 01-10 */}
                                    Showing{" "}
   {filteredObjectCodes.length === 0
       ? 0
       : indexOfFirstRecord + 1}{" "}
   to{" "}
   {Math.min(
       indexOfLastRecord,
       filteredObjectCodes.length
   )}{" "}
   of {filteredObjectCodes.length} entries
    
                               </div>
    
                               {/* Pagination */}
                               <div
                                   style={{
                                       display: "flex",
                                       alignItems: "center",
                                       gap: "20px",
                                   }}
                               >
                                   {/* Previous */}
                                   <button
                                       onClick={() =>
                                           setCurrentPage((prev) =>
                                               Math.max(prev - 1, 1)
                                           )
                                       }
                                       disabled={currentPage === 1}
                                       style={{
                                           border: "none",
                                           background: "transparent",
                                           color:
                                               currentPage === 1
                                                   ? "#999"
                                                   : "#2ea4e7",
                                           cursor:
                                               currentPage === 1
                                                   ? "not-allowed"
                                                   : "pointer",
                                           fontSize: "13px",
                                           padding: 0,
                                           display: "flex",
                                           alignItems: "center",
                                           gap: "4px",
                                           opacity: currentPage === 1 ? 0.5 : 1,
                                       }}
                                   >
                                       <span style={{ fontSize: "18px" }}>‹</span>
                                       Previous
                                   </button>
    
                                   {/* Page Numbers */}
                                   <div
                                       style={{
                                           display: "flex",
                                           alignItems: "center",
                                           gap: "20px",
                                       }}
                                   >
                                       {getPageNumbers(currentPage, totalPages).map(
                                           (pageNumber) => (
                                               <button
                                                   key={pageNumber}
                                                   onClick={() =>
                                                       setCurrentPage(pageNumber)
                                                   }
                                                   style={{
                                                       border: "none",
                                                       background: "transparent",
                                                       padding: 0,
                                                       color:
                                                           currentPage === pageNumber
                                                               ? "#2ea4e7"
                                                               : "#444",
                                                       cursor: "pointer",
                                                       fontSize: "13px",
                                                       fontWeight:
                                                           currentPage === pageNumber
                                                               ? "600"
                                                               : "400",
                                                       textDecoration:
                                                           currentPage === pageNumber
                                                               ? "underline"
                                                               : "none",
                                                   }}
                                               >
                                                   {pageNumber}
                                               </button>
                                           )
                                       )}
                                   </div>
    
                                   {/* Next */}
                                   <button
                                       onClick={() =>
                                           setCurrentPage((prev) =>
                                               Math.min(prev + 1, totalPages)
                                           )
                                       }
                                       disabled={
                                           currentPage === totalPages ||
                                           totalPages === 0
                                       }
                                       style={{
                                           border: "none",
                                           background: "transparent",
                                           color:
                                               currentPage === totalPages ||
                                                   totalPages === 0
                                                   ? "#999"
                                                   : "#2ea4e7",
                                           cursor:
                                               currentPage === totalPages ||
                                                   totalPages === 0
                                                   ? "not-allowed"
                                                   : "pointer",
                                           fontSize: "13px",
                                           padding: 0,
                                           display: "flex",
                                           alignItems: "center",
                                           gap: "4px",
                                           opacity:
                                               currentPage === totalPages ||
                                                   totalPages === 0
                                                   ? 0.5
                                                   : 1,
                                       }}
                                   >
                                       Next
                                       <span style={{ fontSize: "18px" }}>›</span>
                                   </button>
                               </div>
                           </div>
    
               </div>
                   
               
               </div>
           </div>
          
       );
};

export default ObjectCode;